module.exports = __webpack_public_path__ + "img/DW365-033.56b17bad.jpg";